import React, { FC } from 'react';

import { EvIcon, InfoStatusIcon } from '@evinced-private/ui-common';

import './InfoLine.scss';

interface IInfoLine {
	msg: string;
}

const InfoLine: FC<IInfoLine> = ({ msg }) => (
	<div className="info-line-msg">
		<EvIcon icon={InfoStatusIcon} className="info-line-icon" small />
		<p className="info-line-text">{msg}</p>
	</div>
);

export { InfoLine };
